import { IProcessedProfile } from '@/components/profileDetail';

export const showDirectSupport = (
  profile: IProcessedProfile,
  isPreviewMode: boolean,
): boolean => {
  return profile.leadFlag === 'true' && !isPreviewMode;
};
